import {
  GetRegistrationStatusResponse,
  ListAttendeesResponse,
  RegisterEventResponse,
} from "@/gen/ts/v1/event/event_requests_pb";
import { eventClient } from "@/lib/connect.client";
import {
  CancelRegistrationParams,
  GetRegistrationStatusParams,
  ListAttendeesParams,
  RegisterEventParams,
} from "./attendees.shared";

// We can't import serverEventClient here but it should be the same as eventClient
type Client = typeof eventClient;

// ===================================================
// ========== List Attendees ==========
// ===================================================
export function listAttendeesWithClient(client: Client) {
  const fn = async function (
    params: ListAttendeesParams,
  ): Promise<ListAttendeesResponse> {
    return client.listAttendees({
      ...params,
    });
  };

  return fn;
}

// ===================================================
// ========== Register Event ==========
// ===================================================
export function registerEventWithClient(client: Client) {
  const fn = async function (
    params: RegisterEventParams,
  ): Promise<RegisterEventResponse> {
    return client.registerEvent({
      ...params,
    });
  };

  return fn;
}

// ===================================================
// ========== Get Registration Status ==========
// ===================================================
export function getRegistrationStatusWithClient(client: Client) {
  const fn = async function (
    params: GetRegistrationStatusParams,
  ): Promise<GetRegistrationStatusResponse> {
    const response = await client.getRegistrationStatus({
      ...params,
    });
    return response;
  };

  return fn;
}

// ===================================================
// ========== Cancel Registration ==========
// ===================================================
export function cancelRegistrationWithClient(client: Client) {
  const fn = async function (params: CancelRegistrationParams): Promise<void> {
    await client.cancelRegistration({
      ...params,
    });
  };

  return fn;
}
